import { VerticalData } from './vertical';

export const ftaMediaTypeData = [
  {
    name: 'Digital Overall',
    lowerQuartile: '13.9%',
    median: '24%',
    upperQuartile: '36.3%',
  },
  {
    name: 'TV',
    lowerQuartile: '18.3%',
    median: '25.2%',
    upperQuartile: '37.3%',
  },
  {
    name: 'OOH',
    lowerQuartile: '26.1%',
    median: '61%',
    upperQuartile: '100%',
  },
] as const satisfies readonly VerticalData[];

export const ftaDigitalVerticalData = [
  {
    name: 'Auto*',
    lowerQuartile: '25.6%',
    median: '37.3%',
    upperQuartile: '61.2%',
  },
  {
    name: 'Dining',
    lowerQuartile: '14.5%',
    median: '22.9%',
    upperQuartile: '33.9%',
  },
  {
    name: 'Entertainment*',
    lowerQuartile: '25.3%',
    median: '45.1%',
    upperQuartile: '62.8%',
  },
  {
    name: 'Finance*',
    lowerQuartile: '26.5%',
    median: '31.3%',
    upperQuartile: '36.1%',
  },
  {
    name: 'Retail',
    lowerQuartile: '12.6%',
    median: '24.3%',
    upperQuartile: '38%',
  },
  {
    name: 'Telecom*',
    lowerQuartile: '0%',
    median: '14.8%',
    upperQuartile: '23.3%',
  },
  {
    name: 'Travel*',
    lowerQuartile: '18.8%',
    median: '32%',
    upperQuartile: '50.7%',
  },
] as const satisfies readonly VerticalData[];

export const ftaDigitalSubverticalData = [
  {
    name: 'Dining - Fast Casual',
    lowerQuartile: '9.7%',
    median: '20.5%',
    upperQuartile: '34.1%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '14.8%',
    median: '23.4%',
    upperQuartile: '33.9%',
  },
  {
    name: 'Retail - Alc-Bev*',
    lowerQuartile: '20.7%',
    median: '34.2%',
    upperQuartile: '43.1%',
  },
  {
    name: 'Retail - Appliances*',
    lowerQuartile: '0.8%',
    median: '5.8%',
    upperQuartile: '29.7%',
  },
  {
    name: 'Retail - Automotive',
    lowerQuartile: '15.7%',
    median: '30.1%',
    upperQuartile: '39.4%',
  },
  {
    name: 'Retail - Beauty',
    lowerQuartile: '20.4%',
    median: '30.3%',
    upperQuartile: '40.3%',
  },
  {
    name: 'Retail - Big Box',
    lowerQuartile: '14.2%',
    median: '24.3%',
    upperQuartile: '37.9%',
  },
  {
    name: 'Retail - Clothing',
    lowerQuartile: '13.6%',
    median: '22.4%',
    upperQuartile: '41.2%',
  },
  {
    name: 'Retail - Convenience',
    lowerQuartile: '2.9%',
    median: '12.2%',
    upperQuartile: '23.7%',
  },
  {
    name: 'Retail - Drug',
    lowerQuartile: '17.2%',
    median: '24.6%',
    upperQuartile: '38.8%',
  },
  {
    name: 'Retail - Furniture',
    lowerQuartile: '8.6%',
    median: '16.3%',
    upperQuartile: '30.9%',
  },
  {
    name: 'Retail - Grocery',
    lowerQuartile: '15.4%',
    median: '26.4%',
    upperQuartile: '32.8%',
  },
  {
    name: 'Retail - Home Improvement',
    lowerQuartile: '9.2%',
    median: '25.5%',
    upperQuartile: '41.2%',
  },
  {
    name: 'Retail - Pet*',
    lowerQuartile: '22.2%',
    median: '27.2%',
    upperQuartile: '28.8%',
  },
  {
    name: 'Retail - Sporting Goods*',
    lowerQuartile: '24.6%',
    median: '31.2%',
    upperQuartile: '40.4%',
  },
] as const satisfies readonly VerticalData[];

export const ftaTvVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '17.9%',
    median: '24.1%',
    upperQuartile: '37.3%',
  },
  {
    name: 'Retail*',
    lowerQuartile: '26.6%',
    median: '33.6%',
    upperQuartile: '37.0%',
  },
] as const satisfies readonly VerticalData[];

export const ftaTvSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '14.3%',
    median: '18.2%',
    upperQuartile: '19.3%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '18.4%',
    median: '25.6%',
    upperQuartile: '39.1%',
  },
  {
    name: 'Retail - Clothing*',
    lowerQuartile: '35.1%',
    median: '35.1%',
    upperQuartile: '35.1%',
  },
  {
    name: 'Retail - Home Improvement*',
    lowerQuartile: '26.1%',
    median: '32.1%',
    upperQuartile: '38.6%',
  },
] as const satisfies readonly VerticalData[];

export const ftaOohVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '15.9%',
    median: '36.5%',
    upperQuartile: '67.5%',
  },
  {
    name: 'Retail',
    lowerQuartile: '46.4%',
    median: '79.5%',
    upperQuartile: '105.5%',
  },
  {
    name: 'Travel*',
    lowerQuartile: '178.2%',
    median: '241.3%',
    upperQuartile: '304.4%',
  },
] as const satisfies readonly VerticalData[];

export const ftaOohSubverticalData = [
  {
    name: 'Dining - Fast Casual*',
    lowerQuartile: '28.1%',
    median: '56.2%',
    upperQuartile: '58.6%',
  },
  {
    name: 'Dining - QSR*',
    lowerQuartile: '17.7%',
    median: '32.2%',
    upperQuartile: '74.3%',
  },
  {
    name: 'Retail - Alc Bev*',
    lowerQuartile: '9.3%',
    median: '9.3%',
    upperQuartile: '9.3%',
  },
  {
    name: 'Retail - Automotive*',
    lowerQuartile: '57.8%',
    median: '80.3%',
    upperQuartile: '89.3%',
  },
  {
    name: 'Retail - Clothing*',
    lowerQuartile: '78.4%',
    median: '102.7%',
    upperQuartile: '145.8%',
  },
  {
    name: 'Retail - Convenience*',
    lowerQuartile: '0%',
    median: '38.1%',
    upperQuartile: '77.0%',
  },
  {
    name: 'Retail - Drug*',
    lowerQuartile: '124.0%',
    median: '124.0%',
    upperQuartile: '124.0%',
  },
  {
    name: 'Retail - Grocery*',
    lowerQuartile: '46.4%',
    median: '49.3%',
    upperQuartile: '99.4%',
  },
] as const satisfies readonly VerticalData[];
